import React from 'react';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { useText, useImg } from 'hooks';
import { MOBILE, TABLET } from 'helpers/styles/media';

const Features2 = () => {
  return (
    <Wrapper>
      <Container>
        <Title>{useText('features2__title', true)}</Title>
        <List>
          {[...Array(3)].map((i, idx) => {
            const index = idx + 1;
            return (
              <Item key={index}>
                <ItemIcon>
                  {useImg(`icon2_${index}.png`, `features__icon_${index}`)}
                </ItemIcon>
                <ItemTitle>
                  {useText(`features2_item__title_${index}`, true)}
                </ItemTitle>
                <ItemText>
                  {useText(`features2_item__text_${index}`, true)}
                </ItemText>
              </Item>
            );
          })}
        </List>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background: #60523a;
  padding: 48px 0 35px;

  @media ${TABLET} {
    padding: 42px 0 20px;
  }

  @media ${MOBILE} {
    padding: 49px 0 14px;
  }
`;

const Title = styled.div`
  font-weight: 500;
  font-size: 29px;
  line-height: 34px;
  text-align: center;
  color: #eee5cc;
  max-width: 609px;
  margin: 0 auto 60px;
`;

const List = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  column-gap: 39px;
  margin: 0 auto 40px;
  max-width: 1180px;
  margin-top: 30px;

  @media ${TABLET} {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    row-gap: 54px;
  }

  @media ${MOBILE} {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    row-gap: 54px;
  }
`;

const Item = styled.div`
  text-align: center;

  &:first-child {
    max-width: 250px;
  }

  &:last-child {
    max-width: 223px;
  }

  &:nth-child(2) {
    max-width: 233px;
  }

  @media ${TABLET} {
    &:first-child {
      max-width: 400px;
    }

    &:last-child {
      max-width: 400px;
    }

    &:nth-child(2) {
      max-width: 400px;
    }
  }

  @media ${MOBILE} {
    @media ${MOBILE} {
      &:first-child {
        max-width: 250px;
      }

      &:last-child {
        max-width: 250px;
      }

      &:nth-child(2) {
        max-width: 250px;
      }
    }
  }
`;

const ItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 22px;
  img {
    max-height: 50px;
  }

  @media ${MOBILE} {
    margin-bottom: 25px;
  }
`;
const ItemTitle = styled.div`
  font-weight: 500;
  line-height: 17px;
  text-align: center;
  color: #eee5cc;
  margin-top: 10px;
  font-size: 23px;
`;

const ItemText = styled.div`
  font-weight: 400;
  line-height: 17px;
  text-align: center;
  color: #eee5cc;
  margin-top: 10px;
  font-size: 12px;
`;

export default Features2;
